const THEME = {
  colors: {
    grey: '#eff2f5',
    purple: '#db65ff',
  },
  error: {
    backgroundColor: '#fff2f0',
    border: '1px solid #ffccc7',
  },
  info: {
    backgroundColor: '#e6f7ff',
    border: '1px solid #91d5ff',
  },
  success: {
    backgroundColor: '#f6ffed',
    border: '1px solid #b7eb8f',
  },
  padding: '1rem',
}

export default THEME
